import classNames from "classnames";
import { formatIssueTimestamp, getIssueTypeMeta } from "../../_constants/issues.const";
import { Issue } from "../../_types/issues.types";
import styles from "./IssueListItem.module.scss";

type IssueListItemProps = {
  issue: Issue;
  onClick: () => void;
};

export const IssueListItem = ({ issue, onClick }: IssueListItemProps) => {
  const typeMeta = getIssueTypeMeta(issue.errorType);
  const reporterName = issue.reporterName || "Anonymous";
  const reporterEmail = issue.reporterEmail || "No email";
  const modelSlug = issue.modelSlug || "Unknown model";

  return (
    <button
      type="button"
      className={classNames(
        styles["comp"],
        issue.read ? styles["comp--read"] : styles["comp--unread"]
      )}
      onClick={onClick}
    >
      <div className={styles["comp__person"]}>
        <div className={styles["comp__sender"]}>
          <div className={styles["comp__name"]}>{reporterName}</div>
          <div className={styles["comp__email"]}>{reporterEmail}</div>
        </div>
      </div>

      <div className={styles["comp__category"]}>
        <span
          className={classNames(
            styles["comp__badge"],
            styles[`comp__badge--${typeMeta.variant}`]
          )}
        >
          {typeMeta.label}
        </span>
      </div>

      <div className={styles["comp__model"]}>{modelSlug}</div>

      <div className={styles["comp__content"]}>{issue.description}</div>

      <time className={styles["comp__timestamp"]}>
        {formatIssueTimestamp(issue.createdAt)}
      </time>
    </button>
  );
};
